export const createNavigationPaper = (props) => {
    return Object.assign({}, props);
};
